import { AfterViewInit, Component, OnInit } from '@angular/core';
import { InvestigoScanner } from '../../../insurgo-classes/investigo-scanner.class';
import { InvestigoDrive } from '../../../insurgo-classes/investigo-drive.class';
import { ExineAgGrid } from '../../../insurgo-classes/exine-ag-grid';
import { DriveHelperService } from '../../../insurgo-services/drive-helper.service';
import { Hardware, HardwareType } from '../../../insurgo-interfaces/hardware.interface';
import { CheckboxRenderer } from '../../../insurgo-services/cellRenderers/checkbox.renderer.component';
import { DispatchHardwareService } from '../../../insurgo-ui-components/dispatch-hardware/dispatch-hardware.service';
import { ToastService } from '../../../insurgo-services/toast.service';
import { defaultStepOptions } from "../../default-tour-options";
import { steps as defaultSteps } from './hardware-register-tour';
import { ShepherdService } from 'angular-shepherd';
import { UserStore } from '../../../@core/stores/user.store';
import { UserService } from '../../../insurgo-services/user.service';

@Component({
  selector: 'ngx-hardware-register',
  templateUrl: './hardware-register.component.html',
  styleUrls: ['./hardware-register.component.scss']
})
export class HardwareRegisterComponent implements OnInit, AfterViewInit {

  public onSiteDrives: InvestigoDrive[] = [];
  public onSiteScanners: InvestigoScanner[] = [];

  public onSiteDrivesTable = new ExineAgGrid();
  public onSiteScannersTable = new ExineAgGrid();

  public get selectedDrivesCount(): number {
    return this.onSiteDrivesTable.rowData.filter((drive) => drive.uiSelected).length;
  }

  public get selectedScannersCount(): number {
    return this.onSiteScannersTable.rowData.filter((scanner) => scanner.uiSelected).length;
  }

  private readonly guideKey = 'hardware_register';

  constructor(private driveHelperService: DriveHelperService,
    private dispatchHardwareService: DispatchHardwareService,
    private toastService: ToastService,
    private userStore: UserStore,
    private shepherdService: ShepherdService,
    private userService: UserService) {

    const driveColumnDefs = [
      {
        headerName: 'Select',
        field: 'uiSelected',
        minWidth: 120,
        cellRenderer: CheckboxRenderer
      },
      { headerName: 'Asset Tag', field: 'assetTag', minWidth: 120, flex: 1, sortable: true },
      { headerName: 'Type', field: 'driveType', minWidth: 120, flex: 1, sortable: true },
      { headerName: 'Model', field: 'model', minWidth: 120, flex: 1, sortable: true },
      { headerName: 'Drive Name', field: 'driveName', minWidth: 120, flex: 1, sortable: true },
      { headerName: 'Serial', field: 'driveSerial', minWidth: 120, flex: 1, sortable: true },
      // { headerName: 'Sent Date', field: 'sentDateHR', minWidth: 120, flex: 1, sortable: true },
    ];
    this.onSiteDrivesTable.columnDefs = driveColumnDefs;

    const scannerColumnDefs = [
      {
        headerName: 'Select',
        field: 'uiSelected',
        minWidth: 120,
        cellRenderer: CheckboxRenderer
      },
      { headerName: 'Asset Tag', field: 'assetTag', minWidth: 120, flex: 1, sortable: true },
      { headerName: 'Type', field: 'driveType', minWidth: 120, flex: 1, sortable: true },
      { headerName: 'Serial', field: 'driveSerial', minWidth: 120, flex: 1, sortable: true },
      // { headerName: 'Sent Date', field: 'sentDateHR', minWidth: 120, flex: 1, sortable: true },
    ];
    this.onSiteScannersTable.columnDefs = scannerColumnDefs;
  }


  ngOnInit(): void {
    this.getOnSiteHardware();
  }

  public async ngAfterViewInit() {
    const showGuide = this.userStore.isUserGuideActive(this.guideKey);

    if (showGuide) {
      this.shepherdService.defaultStepOptions = defaultStepOptions;
      this.shepherdService.modal = true;
      this.shepherdService.confirmCancel = false;
      this.shepherdService.addSteps(defaultSteps);
      this.shepherdService.start();

      // Listen for tour completion
      this.shepherdService.tourObject.on('complete', () => {
        console.log('Tour completed!');
        this.userService.toggleSingleUserGuide(this.guideKey, false).subscribe({
          next: (res) => {
            this.userStore.setUserGuideOption(res);
          },
          error: (err) => {
            console.error('Error updating user guide settings:', err);
          }
        });
      });
    }
  }

  public async dispatchHardware() {

    // find selected drives 
    const selectedDriveRow = this.onSiteDrivesTable.rowData.filter((drive) => drive.uiSelected);
    const selectedScannerRow = this.onSiteScannersTable.rowData.filter((scanner) => scanner.uiSelected);

    // match by asset tag to get drive and scanner objects
    const selectedDrives = this.onSiteDrives.filter((drive) => selectedDriveRow.find((row) => row.assetTag === drive.assetTag));
    const selectedScanners = this.onSiteScanners.filter((scanner) => selectedScannerRow.find((row) => row.assetTag === scanner.assetTag));

    const result = await this.dispatchHardwareService.show(selectedDrives, selectedScanners);

    if (result && result === 'success') {
      this.toastService.showToast('success', 'Success', 'All hardware dispatched successfully');
    } else if (result && result === 'partial-success') {
      this.toastService.showToast('warning', 'Partial Success', 'Some hardware was not dispatched - please review tables to see those that remain');
    }

    this.getOnSiteHardware();
  }


  public unselectAllDrives() {
    if (this.onSiteDrivesTable.rowData.length === 0) {
      return;
    }
    const updatedRowData = this.onSiteDrivesTable.rowData.map((drive) => ({
      ...drive,
      uiSelected: false,
    }));
    this.onSiteDrivesTable.rowData = updatedRowData;
    // this.onSiteDrivesTable.gridApi.setGridOptionsetRowData(updatedRowData);
    this.onSiteDrivesTable.gridApi.setGridOption("rowData", updatedRowData);

  }

  public unselectAllScanners() {
    if (this.onSiteScannersTable.rowData.length === 0) {
      return;
    }
    const updatedRowData = this.onSiteScannersTable.rowData.map((scanner) => ({
      ...scanner,
      uiSelected: false,
    }));
    this.onSiteScannersTable.rowData = updatedRowData;
    // this.onSiteScannersTable.gridApi.setRowData(updatedRowData);
    this.onSiteScannersTable.gridApi.setGridOption("rowData", updatedRowData);
  }

  public unselectAll() {
    this.unselectAllDrives();
    this.unselectAllScanners();
  }


  public refreshArrivingHardware() {
    this.getOnSiteHardware();
  }

  public onGridReady(params) {
    this.onSiteDrivesTable.gridApi = params.api;
    this.onSiteScannersTable.gridApi = params.api;
  }


  public csvExportDrives() {
    const fileName = `manifest_errors`;
    this.onSiteDrivesTable.gridApi.exportDataAsCsv({ fileName: fileName });

  }
  public csvExportScanners() {
    const fileName = `manifest_errors`;
    this.onSiteScannersTable.gridApi.exportDataAsCsv({ fileName: fileName });

  }

  private getOnSiteHardware() {

    this.onSiteDrives = [];
    this.onSiteScanners = [];
    this.unselectAll();

    this.driveHelperService.getAllHardwareOnSite().subscribe({
      next: (response) => {
        this.convertHardwareToClasses(response);
        this.setOnSiteTables();
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  private convertHardwareToClasses(allHardware: Hardware[]) {
    allHardware.forEach((hardware) => {
      if (hardware.HardwareTypeID === HardwareType.KIT_DRIVE || hardware.HardwareTypeID === HardwareType.SWAT_DRIVE) {
        this.onSiteDrives.push(new InvestigoDrive(hardware));
      } else if (hardware.HardwareTypeID === HardwareType.SCANNER) {
        this.onSiteScanners.push(new InvestigoScanner(hardware));
      }
    });
  }

  private setOnSiteTables() {
    const driveRows = [];
    const scannerRows = [];
    for (const drive of this.onSiteDrives) {
      driveRows.push({
        assetTag: drive.assetTag,
        driveType: drive.driveType,
        driveName: drive.driveName,
        driveSerial: drive.serialNumber,
        model: drive.model,
      });
    }
    for (const scanner of this.onSiteScanners) {
      scannerRows.push({
        assetTag: scanner.assetTag,
        driveType: scanner.isBarcodeEnabled ? 'Barcode' : 'Standard',
        driveSerial: scanner.serialNumber,
      });
    }
    this.onSiteDrivesTable.rowData = driveRows;
    this.onSiteScannersTable.rowData = scannerRows;
  }
}


